export default __webpack_public_path__ + "static/media/arrows-chevron-up.d00a668d.svg";